import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import { Toolbar, AppBar,  Typography, Button } from '@material-ui/core'
import logo from '../../assets/image/logo.png'


const styles = {
  root: {
    flexGrow: 1,
    backgroundColor: 'white',
    underline: 'none'
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  white: {
      background: '#FFF',
  },
  black: {
      color: '#000'
  }
};




function ButtonAppBar(props) {
 // const { classes } = props;
  return <Fragment>
    <div style={styles.root}>
      <AppBar style={styles.white} position="sticky">
        <Toolbar>
         
          <Typography variant="headline" style={styles.grow}>
           <Link style={{textDecoration: 'none', color:'black'}} to="/"><img style={{width: '90px'}} src={logo} alt="WorkOut"/></Link>
          </Typography>
          <Link style={{textDecoration: 'none'}} to="/pricing"><Button style={styles.white}> Pricing </Button></Link> 
          <Link style={{textDecoration: 'none'}} to="/login"><Button style={styles.white}> Login </Button></Link> 
        </Toolbar>
      </AppBar>
    </div>
    </Fragment>
}
export default ButtonAppBar;
